import { LinkProps } from '@material-ui/core/Link';
import React from 'react';
import LinkRouter from '../../common/LinkRouter';

interface Props extends LinkProps {
    deploymentName: string;
    accountId?: string;
    region?: string;
}

function FaroDeckLink(props: Props) {
    const { deploymentName, accountId, region, ...other } = props;
    return (
        <LinkRouter {...other} to={`/faro/deployments/${accountId}/${region}/${deploymentName}`}>{deploymentName}</LinkRouter>
    );
};

export default FaroDeckLink;